<script setup lang="ts">
import BreadcrumItem from './BreadcrumItem.vue';
import type { BreadcrumbLinkItem } from './BreadcrumbLink.vue';

defineProps<{
  /**
   * The items to display in the breadcrumb.
   *
   * If an array is passed, the component will check for the matching route and display.
   */
  items: Array<BreadcrumbLinkItem | Array<BreadcrumbLinkItem>>;
}>();
</script>

<template>
  <ul class="tw-flex tw-gap-2">
    <template v-for="(item, itemIndex) in items" :key="item.to || `breadcrumb_${itemIndex}`">
      <BreadcrumItem :item="item" />
    </template>
  </ul>
</template>

<style scoped></style>
